const es = {
  brand: "EcoGlow Detailing",
  nav: {
    home: "Inicio",
    services: "Servicios",
    packs: "Packs",
    works: "Trabajos",
    center: "Centro",
    zones: "Zonas",
    about: "Nosotros",
    blog: "Blog",
    contact: "Contacto",
    whatsapp: "WhatsApp",
    quote: "Solicitar presupuesto",
  },
  hero: {
    kicker: "Estudio de detailing · Els Muntells, Tarragona",
    h1a: "Detailing profesional en Els Muntells,",
    h1b: "Amposta y alrededores.",
    sub: "Transformamos, cuidamos y protegemos tu vehículo con tratamientos profesionales de detailing.",
    cta1: "Solicitar presupuesto",
    cta2: "Descubrir servicios",
    scroll: "Desliza",
  },
  intro: {
    kicker: "El estándar EcoGlow",
    title: "Más que una limpieza, cuidado profesional para tu vehículo.",
    text: "En EcoGlow Detailing nos especializamos en el cuidado estético del automóvil. Trabajamos cada vehículo con atención al detalle, productos profesionales y tratamientos adaptados a sus necesidades.",
    m1t: "Interior a domicilio",
    m1d: "Limpiezas interiores donde esté tu coche, en toda la zona.",
    m2t: "Centro en Els Muntells",
    m2d: "Nuestro estudio equipado para tratamientos completos.",
    m3t: "Recogida y entrega",
    m3d: "Recogemos tu vehículo y te lo devolvemos terminado.",
  },
  home: {
    servicesKicker: "Servicios",
    servicesTitle: "Tratamientos de detailing profesional",
    servicesSub: "Cada servicio tiene su proceso, sus productos y su acabado. Elige el que necesita tu coche.",
    viewService: "Ver servicio",
    packsKicker: "Packs EcoGlow",
    packsTitle: "Packs pensados para tu coche",
    packsCta: "Consultar packs y precios",
    recommended: "Recomendado",
    worksKicker: "Trabajos realizados",
    worksTitle: "El resultado habla por sí solo",
    worksPlaceholder: "Estamos preparando nuestra galería de trabajos reales: antes y después, proceso y resultado. Muy pronto podrás ver aquí lo que hacemos en el centro.",
    worksNote: "Fotografía de referencia: los trabajos reales se publicarán aquí próximamente.",
    worksCta: "Ver todos los trabajos",
    whyKicker: "Por qué EcoGlow",
    whyTitle: "Por qué elegir EcoGlow Detailing",
    why: [
      { t: "Atención personalizada", d: "Cada coche se evalúa antes de proponerte nada. Sin plantillas." },
      { t: "Productos profesionales", d: "Química y consumibles de gama profesional, no de supermercado." },
      { t: "Acabados cuidados", d: "El detalle es nuestro oficio: juntas, gomas, rejillas, tapicería." },
      { t: "Tratamientos especializados", d: "Pulido, corrección de pintura, cerámica y Fusso Coat." },
      { t: "Centro físico", d: "Un estudio real en Els Muntells donde dejamos tu coche a punto." },
      { t: "Recogida y entrega", d: "No te muevas: recogemos y devolvemos tu vehículo." },
      { t: "Interior a domicilio", d: "La limpieza interior también en tu casa o trabajo." },
    ],
    zonesKicker: "Zonas de servicio",
    zonesTitle: "Trabajamos en toda la zona",
    zonesSub: "Centro en Els Muntells y servicio móvil de limpieza interior en las localidades cercanas.",
    reviewsKicker: "Opiniones",
    reviewsTitle: "Lo que dicen nuestros clientes",
    reviewsEmpty: "Solo mostramos opiniones reales de nuestros clientes publicadas en Google: nada inventado. Si ya has pasado por EcoGlow, tu reseña nos ayuda mucho.",
    reviewsGmb: "Dejar una reseña en Google",
    faqKicker: "Preguntas frecuentes",
    faqTitle: "Resolvemos tus dudas",
    contactKicker: "Contacto",
    contactTitle: "Pide tu presupuesto sin compromiso",
    contactSub: "Cuéntanos qué necesita tu coche y te respondemos por WhatsApp.",
  },
  faqs: [
    { q: "¿Dónde estáis?", a: "Nuestro centro está en Els Muntells (Tarragona). Por privacidad no publicamos la dirección exacta: al reservar te indicamos cómo llegar. También trabajamos con recogida y entrega del vehículo." },
    { q: "¿Hacéis servicio a domicilio?", a: "Sí, pero actualmente el servicio a domicilio es exclusivamente para limpiezas interiores. Los tratamientos de pintura, pulido y protección se realizan en nuestro centro de Els Muntells." },
    { q: "¿Cómo funciona la recogida y entrega?", a: "Recogemos tu vehículo en la zona (Amposta, Deltebre, Sant Jaume d'Enveja, La Ràpita, Tortosa y alrededores), realizamos el tratamiento en el centro y te lo devolvemos terminado. Consúltanos disponibilidad." },
    { q: "¿Cuánto cuesta?", a: "Los precios dependen del servicio y del tamaño del vehículo (S, M o XL). Consulta la página de packs y precios o pídenos presupuesto por WhatsApp sin compromiso." },
    { q: "¿Qué significa S, M y XL?", a: "Es la categoría según el tamaño del coche: S para utilitarios y compactos, M para berlinas y SUV medios, XL para SUV grandes, 4x4 y furgonetas. Si tienes dudas, te confirmamos la categoría de tu modelo." },
    { q: "¿Cómo reservo?", a: "La forma más rápida es por WhatsApp al 691 622 449. Cuéntanos el servicio que quieres, tu modelo de coche y tu localidad, y te proponemos fecha." },
    { q: "¿Cuánto dura el tratamiento cerámico o el Fusso Coat?", a: "El Fusso Coat anuncia una duración de hasta 12 meses según las condiciones de uso. En el caso del tratamiento cerámico, la duración depende del producto, del uso y del mantenimiento: te lo explicamos en persona sin promesas infladas." },
  ],
  contact: {
    title: "Contacto",
    kicker: "Contacto",
    heading: "Hablemos de tu coche",
    sub: "Rellena el formulario y se abrirá WhatsApp con tu mensaje ya redactado. También puedes llamarnos directamente.",
    name: "Nombre",
    phone: "Teléfono",
    model: "Marca y modelo",
    service: "Servicio solicitado",
    size: "Tamaño del vehículo",
    locality: "Localidad",
    message: "Mensaje",
    send: "Enviar por WhatsApp",
    call: "Llamar ahora",
    wa: "Abrir WhatsApp",
    selectService: "Selecciona un servicio",
    selectSize: "Selecciona el tamaño",
    sizeS: "S · Utilitario / compacto",
    sizeM: "M · Berlina / SUV medio",
    sizeXL: "XL · SUV grande / 4x4 / furgoneta",
    notSure: "No estoy seguro",
    infoCenter: "Centro físico en Els Muntells (la dirección exacta se facilita al reservar)",
    infoPickup: "Recogida y entrega de vehículos en la zona",
    infoHome: "Limpieza interior a domicilio",
    sent: "Se abrirá WhatsApp con tu mensaje listo para enviar.",
  },
  servicesPage: {
    kicker: "Servicios",
    title: "Servicios de detailing profesional",
    sub: "Cuidado interior, exterior, corrección de pintura y protección. Cada tratamiento con su proceso y su acabado, en nuestro centro de Els Muntells o, en el caso de la limpieza interior, también a domicilio.",
    includes: "Incluye",
    cta: "Pedir presupuesto",
  },
  servicePage: {
    includes: "Qué incluye",
    process: "El proceso",
    where: "Dónde se realiza",
    faq: "Preguntas frecuentes",
    ctaTitle: "¿Lo hablamos?",
    ctaText: "Cuéntanos tu modelo y el estado del coche y te damos presupuesto cerrado por WhatsApp.",
    related: "Servicios relacionados",
    back: "Todos los servicios",
    priceNote: "Precio según tamaño del vehículo. Consulta packs y precios.",
  },
  packs: {
    kicker: "Packs y precios",
    title: "Packs y precios EcoGlow",
    sub: "Precios claros según el tamaño de tu vehículo. S: utilitarios y compactos · M: berlinas y SUV medios · XL: SUV grandes, 4x4 y furgonetas. Si no sabes la categoría de tu coche, te la confirmamos por WhatsApp.",
    cleaning: "Limpieza",
    correction: "Corrección",
    protection: "Protección",
    packsTitle: "Packs",
    extras: "Extras",
    packContents: "Composición del pack",
    cta: "Pedir presupuesto",
    note: "Fusso Coat y tratamiento cerámico se presupuestan como complemento (+) sobre el servicio base. Todos los precios con IVA incluido según tarifa vigente.",
    packNames: { esencial: "Rejuvenecimiento Esencial", escudo: "Escudo Total", maxima: "Máxima Protección" },
    packItems: {
      esencial: ["Limpieza interior profunda", "Limpieza exterior completa"],
      escudo: ["Limpieza interior profunda", "Limpieza exterior completa", "Descontaminación", "Pulido One-Step", "Protección Fusso Coat"],
      maxima: ["Limpieza interior profunda", "Limpieza exterior completa", "Descontaminación", "Pulido de dos pasos", "Tratamiento cerámico profesional", "Tratamiento de cristales de cortesía"],
    },
    sizeNote: "S, M y XL corresponden al tamaño del vehículo. Consúltanos la categoría de tu coche.",
  },
  worksPage: {
    kicker: "Trabajos realizados",
    title: "Trabajos realizados",
    sub: "Antes y después, proceso y resultado. Solo trabajos reales hechos en EcoGlow.",
    empty: "Estamos documentando nuestros primeros trabajos con fotografías reales de antes y después. Muy pronto verás aquí los proyectos del centro. Mientras tanto, pídenos ejemplos por WhatsApp y te los enseñamos.",
    vehicle: "Vehículo",
    service: "Servicio",
    process: "Proceso",
    result: "Resultado",
  },
  center: {
    kicker: "Nuestro centro",
    title: "Nuestro centro en Els Muntells",
    sub: "Un espacio pensado para trabajar tu coche con la calma y la precisión que el detailing exige.",
    body1: "El corazón de EcoGlow Detailing es nuestro centro de trabajo en Els Muntells (Tarragona). Es aquí donde realizamos los tratamientos más exigentes: pulido, corrección de pintura, Fusso Coat y tratamiento cerámico.",
    body2: "Por privacidad no publicamos la dirección postal exacta: al confirmar tu reserva te indicamos cómo llegar y dónde dejar el vehículo.",
    f1t: "Iluminación de inspección",
    f1d: "Luz específica para detectar defectos de pintura antes y después del pulido.",
    f2t: "Productos profesionales",
    f2d: "Química de detailing de gama profesional para cada superficie.",
    f3t: "Trabajo sin prisas",
    f3d: "Cada coche tiene su tiempo. No trabajamos en cadena.",
    pickup: "¿No puedes venir? Recogemos tu vehículo y te lo devolvemos terminado.",
  },
  zones: {
    kicker: "Zonas de servicio",
    title: "Zonas de servicio",
    sub: "Centro físico en Els Muntells, recogida y entrega en la comarca y limpieza interior a domicilio en las localidades cercanas.",
    centerZone: "Centro físico",
    centerDesc: "Todos los servicios: limpiezas, pulido, corrección, Fusso Coat y cerámica.",
    mobileZone: "Servicio móvil",
    mobileDesc: "Limpieza interior a domicilio. El resto de servicios se realizan en el centro o con recogida y entrega.",
    howTitle: "Cómo funciona",
    how1: "Reserva por WhatsApp indicando tu localidad.",
    how2: "Para limpieza interior, vamos a tu domicilio. Para el resto, recogemos tu coche o lo traes al centro.",
    how3: "Te devolvemos el vehículo terminado, donde te venga mejor.",
    note: "¿Tu localidad no aparece? Escríbenos: valoramos desplazamientos cercanos.",
  },
  about: {
    kicker: "Sobre EcoGlow",
    title: "Sobre EcoGlow Detailing",
    body1: "EcoGlow Detailing nace en Els Muntells, en pleno Delta del Ebro, con una idea clara: tratar cada coche como si fuera el nuestro. Ni lavados exprés ni soluciones milagrosas: proceso, producto profesional y atención al detalle.",
    body2: "Vivimos en una zona exigente para la pintura: sol, salitre, polvo y arena del Delta. Por eso nos especializamos no solo en limpiar, sino en corregir y proteger, para que el resultado dure.",
    body3: "Trabajamos de tres formas: en nuestro centro de Els Muntells, con recogida y entrega del vehículo, y a domicilio para limpiezas interiores. Tú eliges cómo te viene mejor.",
    v1t: "Detalle",
    v1d: "El detailing es precisamente eso: cuidar lo que nadie mira.",
    v2t: "Honestidad",
    v2d: "Te decimos lo que tu coche necesita y lo que no. Sin humo.",
    v3t: "Cercanía",
    v3d: "Un negocio local que responde por WhatsApp, como debe ser.",
  },
  blog: {
    kicker: "Blog",
    title: "Blog de detailing",
    sub: "Guías y consejos de cuidado del automóvil, escritos desde la experiencia del centro.",
    read: "Leer artículo",
    min: "min de lectura",
    back: "Volver al blog",
    related: "Servicios relacionados",
    more: "Más artículos",
  },
  reviews: {
    basedOn: "Basado en 9 reseñas de Google",
    readAll: "Ver todas las reseñas en Google",
  },
  footer: {
    desc: "Detailing profesional en Els Muntells, Tarragona. Limpieza, corrección y protección estética de vehículos.",
    services: "Servicios",
    company: "Empresa",
    contact: "Contacto",
    zonesTitle: "Zonas de servicio",
    rights: "Todos los derechos reservados.",
    madeIn: "Els Muntells · Delta del Ebro",
  },
  floating: { quote: "Presupuesto" },
  seo: {
    home: { title: "Detailing profesional en Els Muntells, Amposta y alrededores | EcoGlow Detailing", desc: "Transformamos, cuidamos y protegemos tu vehículo. Limpieza interior y exterior, pulido, tratamiento cerámico y Fusso Coat en Els Muntells, Tarragona." },
    services: { title: "Servicios de detailing profesional | EcoGlow Detailing", desc: "Limpieza interior y exterior, detailing integral, pulido, corrección de pintura, cerámica, Fusso Coat y restauración de faros en Els Muntells y alrededores." },
    packs: { title: "Packs y precios de detailing | EcoGlow Detailing", desc: "Precios claros por tamaño de vehículo: limpiezas, pulidos, protecciones y packs completos de detailing en Els Muntells, Tarragona." },
    works: { title: "Trabajos realizados | EcoGlow Detailing", desc: "Galería de trabajos reales de detailing en Els Muntells: antes y después, proceso y resultado." },
    center: { title: "Nuestro centro de detailing en Els Muntells | EcoGlow Detailing", desc: "Conoce el centro de EcoGlow Detailing en Els Muntells: iluminación de inspección, productos profesionales y trabajo sin prisas." },
    zones: { title: "Zonas de servicio: Els Muntells, Amposta, Deltebre, Tortosa | EcoGlow Detailing", desc: "Servicio de detailing en Els Muntells, Amposta, Deltebre, Sant Jaume d'Enveja, La Ràpita, Tortosa y localidades cercanas." },
    about: { title: "Sobre EcoGlow Detailing | Detailing profesional en el Delta del Ebro", desc: "Conoce EcoGlow Detailing: cuidado estético profesional del automóvil en Els Muntells, Tarragona." },
    contact: { title: "Contacto y presupuesto | EcoGlow Detailing", desc: "Pide presupuesto de detailing por WhatsApp. Centro en Els Muntells, recogida y entrega, y limpieza interior a domicilio." },
    blog: { title: "Blog de detailing y cuidado del coche | EcoGlow Detailing", desc: "Guías de detailing, pulido, cerámica y cuidado del automóvil escritas por profesionales en Els Muntells." },
  },
};

export default es;
